import { create } from 'zustand';

interface PurchaseStore {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  refetchBalance: (() => void) | null;
  setRefetchBalance: (fn: (() => void) | null) => void;
}

export const usePurchaseStore = create<PurchaseStore>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  refetchBalance: null,
  setRefetchBalance: (fn) => set({ refetchBalance: fn }),
}));
